export const SET_EXPORT_PROCESSING = "SET_EXPORT_PROCESSING";

export const setExportProcessing = (processing = false) => dispatch => {
    dispatch({
        type: SET_EXPORT_PROCESSING,
        payload: processing
    });
};